import { algoliaClient } from '../api/algolia/algolia.client';
import { debounce } from '../js/debounce';
import { getStringCombinations } from '../utils/getStringCombinations';
import { dlSearchEvent } from '../events/search/dl.search.event';
const vn = window.vNode;
const SESSION_KEY = 'r_searches';
class ComponentSearchForm extends HTMLElement {
    client = algoliaClient('K2CTT24UP3', '2ddbb0a8db153957543d851ca677c689').initIndex('Shopify Collections');
    recentData = JSON.parse(window.sessionStorage.getItem(SESSION_KEY) ?? '[]');
    redirectTo = null;
    updateProcess = false;
    form = null;
    input = null;
    btn = null;
    overlay = null;
    hide;
    connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.btn = this.querySelector('button');
        this.overlay = document.querySelector('.main-overlay');
        this.changeDisabledState();
        this.input?.addEventListener('input', this.changeDisabledState.bind(this));
        const submitHandler = (e) => {
            if (this.input === null)
                return;
            const target = this.redirectTo ?? `/search/?q=${this.input.value}`;
            this.addItemToRecent(this.input.value, target);
            window.location.href = target;
        };
        this.form?.addEventListener('submit', e => {
            e.preventDefault();
            this.loading = true;
            if (this.updateProcess) {
                const interval = setInterval(() => {
                    if (this.updateProcess)
                        return;
                    clearInterval(interval);
                    submitHandler(e);
                }, 200);
            }
            else {
                submitHandler(e);
            }
        });
        this.initSuggestions();
        this.loading = false;
        window.addEventListener('pageshow', (event) => {
            if (event.persisted)
                this.loading = false;
        });
    }
    changeDisabledState() {
        if (this.input === null)
            return;
        this.disabled = this.input.value.length < 3;
    }
    addItemToRecent(name, link) {
        this.recentData = [
            { name, link },
            ...this.recentData.filter(item => item.name !== name)
        ];
        if (this.recentData.length > 5) {
            this.recentData.length = 5;
        }
        window.sessionStorage.setItem('r_searches', JSON.stringify(this.recentData));
    }
    initSuggestions() {
        const input = this.input;
        if (input === null)
            return;
        let showed = false;
        let elementsForFocus = [];
        let suggestionsVNode = null;
        const render = async () => {
            this.updateProcess = true;
            const recentItems = showed && this.recentData.length > 0
                ? [
                    vn.create('p', {
                        class: 'sfc__suggestions_items-title d:flex ai:end fw:700'
                    }, [
                        'Recent Searches',
                        vn.create('button', {
                            class: 'sfc__suggestions_items_clear-btn d:flex ai:center btn:cleared fw:400 ml:auto hover:text:underline',
                            events: {
                                click: () => {
                                    this.recentData = [];
                                    window.sessionStorage.removeItem(SESSION_KEY);
                                    void render();
                                }
                            }
                        }, ['Clear recent searches'])
                    ]),
                    vn.create('ul', {
                        class: 'sfc__suggestions_items list:none'
                    }, this.recentData.map(item => {
                        return vn.create('li', {
                            class: 'sfc__suggestions_item',
                            key: item.name
                        }, [
                            vn.create('a', {
                                href: item.link,
                                class: 'sfc__suggestions_item_link sfc__suggestions_item_link--recent d:block trs:all:003',
                                'data-ga-event': `["Search suggestions", "click", "Recent : ${item.name}"]`,
                                events: {
                                    click: () => {
                                        this.addItemToRecent(item.name, item.link);
                                        this.loading = true;
                                        hide();
                                    }
                                }
                            }, [
                                vn.create('div', {
                                    class: 'sfc__suggestions_item_title d:flex ai:center m:0'
                                }, [
                                    vn.create('s-svg', { 'data-icon': '#icon__header_search' }),
                                    item.name
                                ])
                            ])
                        ]);
                    }))
                ]
                : [];
            const result = input.value.length < 3 || !showed
                ? null
                : await this.client.search(input.value, {
                    explain: ['*'],
                    ignorePlurals: true
                });
            const items = result?.hits?.slice(0, 5) ?? [];
            const popularItems = items.length < 1
                ? []
                : [
                    vn.create('p', {
                        class: 'sfc__suggestions_items-title fw:700'
                    }, ['Popular Searches']),
                    vn.create('ul', {
                        class: 'sfc__suggestions_items list:none'
                    }, items.map(item => {
                        return vn.create('li', {
                            class: 'sfc__suggestions_item',
                            key: item.objectID
                        }, [
                            vn.create('a', {
                                href: `/collections/${item.Handle}`,
                                class: 'sfc__suggestions_item_link d:block trs:all:003',
                                'data-ga-event': `["Search suggestions", "click", "${item['Adjusted Title']}"]`,
                                events: {
                                    click: () => {
                                        this.addItemToRecent(item['Adjusted Title'], `/collections/${item.Handle}`);
                                        this.loading = true;
                                        hide();
                                    }
                                }
                            }, [
                                vn.create('div', {
                                    class: 'sfc__suggestions_item_title d:flex ai:center m:0'
                                }, [
                                    vn.create('s-svg', { 'data-icon': '#icon__header_search' }),
                                    item._highlightResult['Adjusted Title'].value
                                ]),
                                vn.create('p', {
                                    class: 'sfc__suggestions_item_category lh:1'
                                }, [
                                    vn.create('span', item.Parent.length > 0 && item['Parent Handle'].length > 0
                                        ? [
                                            'in ', vn.create('a', { class: 'sfc__suggestions_item_category_link', href: `/collections/${item['Parent Handle']}` }, [item.Parent])
                                        ]
                                        : [
                                            item['Template Suffix'].replace('topic', 'subject')
                                        ])
                                ])
                            ])
                        ]);
                    }))
                ];
            const newVNode = popularItems.length < 1 && recentItems.length < 1
                ? null
                : vn.create('div', {
                    class: 'sfc__suggestions pos:a z:2 l:0 w:100'
                }, [
                    ...recentItems,
                    ...popularItems
                ]);
            if (showed) {
                this.setAttribute('data-focus', '');
            }
            else {
                this.removeAttribute('data-focus');
            }
            if (this.overlay !== null) {
                if (showed) {
                    this.overlay.setAttribute('style', '--z-index: 496; transition: opacity .2s ease; background: rgb(255 255 255 / 90%);');
                    this.overlay.setAttribute('aria-hidden', 'false');
                }
                else {
                    this.overlay.setAttribute('aria-hidden', 'true');
                    this.overlay.removeAttribute('style');
                }
            }
            vn.patch(suggestionsVNode, newVNode, this);
            suggestionsVNode = newVNode;
            if (showed && result !== null) {
                try {
                    const redirect = result.userData?.find(({ redirect }) => redirect !== undefined)?.redirect;
                    if (redirect !== undefined) {
                        this.redirectTo = redirect.url;
                    }
                    else {
                        const variants = [];
                        const words = result.explain?.match?.alternatives?.reduce((arr, { types, words, offset }) => {
                            if (types[0] === 'concat') {
                                variants.push(...words);
                            }
                            if (types[0] === 'original' || types[0] === 'plural') {
                                if (arr[offset] !== undefined) {
                                    arr[offset].push(...words);
                                }
                                else {
                                    arr[offset] = words;
                                }
                            }
                            return arr;
                        }, []);
                        words?.length > 0 && variants.push(...getStringCombinations(words));
                        this.redirectTo = (() => {
                            for (const word of variants) {
                                for (const { 'Adjusted Title': title, Handle } of result.hits) {
                                    if (title.toLowerCase() === word) {
                                        return `/collections/${Handle}`;
                                    }
                                }
                            }
                            return null;
                        })();
                    }
                }
                catch (e) {
                    console.log(e);
                    this.redirectTo = null;
                }
            }
            else {
                this.redirectTo = null;
            }
            if (showed) {
                elementsForFocus = [...document.querySelectorAll('.sh__search_input, .sfc__suggestions_item_link')];
                document.addEventListener('mousedown', documentClickHandler);
                document.addEventListener('keydown', documentKeyHandler);
                window.innerWidth < 1024 && window.addEventListener('scroll', defocusInputWithScroll);
                input.value.length > 2 && dlSearchEvent({
                    query: input.value,
                    redirectTo: this.redirectTo
                });
            }
            else {
                elementsForFocus = [];
                document.removeEventListener('mousedown', documentClickHandler);
                document.removeEventListener('keydown', documentKeyHandler);
                window.innerWidth < 1024 && window.removeEventListener('scroll', defocusInputWithScroll);
            }
            this.updateProcess = false;
        };
        const debouncedRender = debounce(render, 300);
        const show = () => {
            showed = true;
            void render();
        };
        const hide = () => {
            if (!showed)
                return;
            showed = false;
            void render();
        };
        this.hide = hide;
        const defocusInputWithScroll = () => {
            this.btn?.focus();
        };
        const documentClickHandler = (event) => {
            if (!(event.target instanceof Element) ||
                event.target === this ||
                this.contains(event.target)) {
                return;
            }
            hide();
        };
        const documentKeyHandler = (event) => {
            if (document.activeElement === null || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp'))
                return;
            event.preventDefault();
            const activeIndex = elementsForFocus.indexOf(document.activeElement);
            if (event.key === 'ArrowDown') {
                const nextElem = elementsForFocus[activeIndex + 1 < elementsForFocus.length ? activeIndex + 1 : 0];
                nextElem.focus();
            }
            else {
                const nextElem = elementsForFocus[activeIndex - 1 > -1 ? activeIndex - 1 : elementsForFocus.length - 1];
                nextElem.focus();
            }
        };
        input.addEventListener('focus', () => {
            if (showed)
                return;
            show();
        });
        input.addEventListener('input', () => {
            this.updateProcess = true;
            debouncedRender();
        });
    }
    get loading() {
        return this.hasAttribute('data-loading');
    }
    set loading(val) {
        if (val) {
            this.setAttribute('data-loading', '');
        }
        else {
            this.removeAttribute('data-loading');
        }
    }
    get disabled() {
        return this.hasAttribute('data-disabled');
    }
    set disabled(val) {
        if (val) {
            this.setAttribute('data-disabled', '');
        }
        else {
            this.removeAttribute('data-disabled');
        }
    }
}
window.customElements.define('search-form-component', ComponentSearchForm);
